<script setup lang="ts">
import PageTitle from '@/components/PageTitle.vue'

import { customElementPropsKey } from '@/types/customElementProps.types'
import { inject, ref } from 'vue'

const templateProps = inject(customElementPropsKey)
const formIsValid = ref(false)
const username = ref('')
</script>

<template>
  <div>
    <PageTitle
      :title="$t('reset-password.card.title')"
      :subtitle="$t('reset-password.info')"
    />

    <v-form
      v-model="formIsValid"
      :action="templateProps?.loginActionUrl"
      method="post"
      novalidate
      class="my-6"
    >
      <v-input>
        <v-text-field
          v-model="username"
          type="email"
          autofocus
          name="username"
          autocomplete="username"
          :label="$t('register.email.label')"
          :rules="[v => !!v || $t('error.field.required')]"
        />
      </v-input>

      <v-input>
        <v-btn block type="submit" :disabled="!formIsValid">{{
          $t('reset-password.submit.button')
        }}</v-btn>
      </v-input>

      <v-input>
        <v-btn block variant="text" :href="templateProps?.loginUrl">{{
          $t('cancel')
        }}</v-btn>
      </v-input>
    </v-form>
  </div>
</template>
